const EXACT_FR_MESSAGES: Record<string, string> = {
  'A client with this phone number already exists':
    'Un client avec ce numéro de téléphone existe déjà.',
  'An account with this email already exists':
    'Un compte avec cet e-mail existe déjà.',
  'Client already exists with this email or phone number':
    'Un client existe déjà avec cet e-mail ou ce numéro de téléphone.',
  'Appointment time is outside shop opening hours':
    'L’horaire du rendez-vous est en dehors des horaires d’ouverture du shop.',
  'This time slot is already reserved in this shop':
    'Ce créneau est déjà réservé dans ce shop.',
  'Invalid scheduledAt value':
    'La date et l’heure de début sont invalides.',
  'estimatedEndTime must be after scheduledAt':
    'La date et l’heure de fin doivent être postérieures à la date et l’heure de début.',
  'shopId, scheduledAt and estimatedEndTime are required for piercing reservations':
    'Le shop, l’heure de début et l’heure de fin sont requis pour réserver un piercing.',
  'serviceId is required':
    'La prestation est requise.',
  'Shop not found':
    'Shop introuvable.',
  'Failed to create appointment':
    'Échec de la création du rendez-vous.',
  'Failed to create client':
    'Impossible de créer le client.',
  'Unable to calculate appointment duration':
    'Impossible de calculer la durée du rendez-vous.',
  'Client created successfully':
    'Client créé avec succès.',
  'Appointment created successfully':
    'Rendez-vous créé avec succès.',
};

const MIN_DURATION_MESSAGE = /^estimatedEndTime must leave at least (\d+) minutes for the requested acts$/;

export function localizeAppointmentApiMessage(message?: string | null): string | null {
  if (!message) return null;
  const exact = EXACT_FR_MESSAGES[message];
  if (exact) return exact;
  const durationMatch = message.match(MIN_DURATION_MESSAGE);
  if (durationMatch) {
    return `La durée doit être d’au moins ${durationMatch[1]} min pour les actes demandés.`;
  }
  return message;
}
